import axios from "axios";

const API_URL = 'https://api.pagar.me/core/v5/';
const appId = process.env.REACT_APP_PAGAR_CLIENT_ID;

export function tokenizeCard(data) {
  return new Promise((resolve, reject) => {
    axios.post(API_URL + `tokens?appId=${appId}`, data, {
      headers: {
        'Content-Language': 'pt-BR',
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}